import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { blastKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useBlasts = (params) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('blasts/list/'), {
            ...additional,
            params
        }),
        queryKey: blastKeys.listFor(params),
        staleTime: 30_000
    });
};
export default useBlasts;
